import { ATSTabbedJobViewAutomationsTabTestIds } from 'data-testids/ATS';
import { AutomationList } from 'features/Automations/AutomationList/AutomationList';
import { AutomationModalPaneOptions } from 'features/Automations/enums';
import { HasAutomationsProps } from '../types';
import { SecondaryButton } from '../styles';
import { useAutomation } from 'features/Automations/context/AutomationContext';
import { useQueryGetAutomationsListData } from 'features/Automations/api/listQueries';
import { filterGeneralAutomations } from 'features/Automations/utils';

export const HasAutomations = ({ onOpenModal }: HasAutomationsProps) => {
  const { onChangeModalPane, setSelectedQuestionId } = useAutomation();
  const { roleId } = useAutomation();
  const { data } = useQueryGetAutomationsListData(roleId);
  const generalAutomations = data ? filterGeneralAutomations(data) : [];

  const handleEditClick = () => {
    onChangeModalPane(AutomationModalPaneOptions.LIST);
    setSelectedQuestionId(null);
    onOpenModal();
  };

  return (
    <>
      <AutomationList
        variant="read_only"
        automationState={{ automations: generalAutomations, hasUnsavedChanges: false }}
        automationDispatch={() => {}}
      />
      <SecondaryButton
        data-testid={ATSTabbedJobViewAutomationsTabTestIds.EDIT_AUTOMATION_BUTTON}
        variant="outlined"
        sx={{ borderRadius: 2, width: '30%' }}
        onClick={handleEditClick}
      >
        Edit
      </SecondaryButton>
    </>
  );
};
